<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'

const multilineString = `以数字科技赋能产业发展，
让招商从“大海捞针”到“精准狙击”`
</script>

<template>
  <div class="industryPart w-full">
    <div class="w-full">
      <div>
        <TitleTwo
          title="一底座、两终端"
          top="24px"
          bottom="20px"
          :sub-title="multilineString"
        />
      </div>
      <div class="w-full relative h-[370px]">
        <div class="w-full relative z-10">
          <img
            src="https://static.idicc.cn/cdn/official/H5/attract_bottom1.png"
            alt=""
            class="w-[132px] absolute left-[32px] top-[10px]"
          >
          <img
            src="https://static.idicc.cn/cdn/official/H5/attract_bottom2.png"
            alt=""
            class="w-[535px] absolute right-[32px] top-[64px]"
          >
        </div>
        <img
          src="https://static.idicc.cn/cdn/official/H5/attract_bottom3.png"
          alt=""
          class="w-full absolute left-0 bottom-0 z-1"
        >
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.industryPart {
  margin-top: 64px;
  background: #F2F5FF;
  padding-top: 32px;
}
</style>
